import { render, staticRenderFns } from "./BungaGadai.vue?vue&type=template&id=e0f16972&scoped=true&"
import script from "./BungaGadai.vue?vue&type=script&lang=js&"
export * from "./BungaGadai.vue?vue&type=script&lang=js&"
import style0 from "./BungaGadai.vue?vue&type=style&index=0&id=e0f16972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f16972",
  null
  
)

export default component.exports